import {Palette} from '@material-ui/core/styles/createPalette';
import {darken, lighten} from '@material-ui/core/styles';
import {common} from './common';

/**
 * Primary blue color
 * Used for
 *   - all logos
 *   - text/links over 18px
 *   - primary buttons
 *
 */
const mediaflyPacific = '#039DDB';

/**
 * Darker variant of mediaflyPacific
 * Used for all isolated icons and text/links 18px or smaller
 *
 * Adds 20% black because mediaflyPacific doesn't pass accessibility
 * standards for smaller text
 *
 */
const mediaflyPacificDark = '#0281B4';

const success = '#7cb933';
const error = '#f44336';
const primary = mediaflyPacific;
const secondary = '#EC6225';
const icon = '#B7C0C8';

function paletteColor(color: string, contrastText = '#fff') {
  return {
    dark: darken(color, 0.2),
    main: color,
    light: lighten(color, 0.2),
    contrastText,
  };
}

const palette: Partial<Palette> = {
  background: {
    paper: '#ffffff',
    default: '#E9EBED',
  },
  divider: '#DDDDDD',
  primary: {
    main: primary,
    dark: mediaflyPacificDark,
    light: lighten(primary, 0.2),
    contrastText: '#fff',
  },
  secondary: paletteColor(secondary),
  success: paletteColor(success),
  error: paletteColor(error),
  icon: {
    primary,
    grey: icon,
    darkGrey: darken(icon, 0.2),
  },
  link: {
    small: mediaflyPacificDark,
    large: mediaflyPacific,
  },
};

export const mediaflyTheme = common(palette);
